import { render, staticRenderFns } from "./UploadPhoto.vue?vue&type=template&id=ed05f040&"
import script from "./UploadPhoto.vue?vue&type=script&lang=js&"
export * from "./UploadPhoto.vue?vue&type=script&lang=js&"
import style0 from "./UploadPhoto.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports